import angular from 'angular';
import uiRouter from 'angular-ui-router';

import mapCategoriesComponent from './map-categories.component';
import mapCategoriesService from './map-categories.service';
import './map-categories.scss';

export default
  angular.module('components.app.admin.map-categories', [
    uiRouter
  ])
    .component('mapCategories', mapCategoriesComponent)
    .service('MapCategoriesService', mapCategoriesService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('mapCategories', {
          parent: 'admin',
          url: '/map-categories',
          component: 'mapCategories',
          resolve: {
            flex: () => '100',
            layout: () => 'column'
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.module.js